import { call, put } from "redux-saga/effects"
import { push } from 'connected-react-router'
import { Modal } from 'antd'
import axios from 'axios'
import config from '../config'

import { 
    sendContactSuccess,sendContactFailed
} from "../actions/contact"


import { resetAuth } from "../actions/auth"

export function* sendContactUs(action) {
    const messageData = {...action.payload}
    const url = config.API_URL + `/contact`
    try {
        const { 
            title,
            email,
            message
        } = messageData

        const formData = new FormData()
        formData.append("title", title)
        formData.append("email", email)
        formData.append("message", message)
        const response = yield axios({
            method: 'post',
            url: url,
            data: formData,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        if(response.data.successful){
            yield put(sendContactSuccess(response.data.message))
            window.location.reload()
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(sendContactFailed(message))
    }
}
